import client from './client';
import type { Category } from '@/types/api';

export const categoriesApi = {
  getAll: async (includeInactive = false): Promise<Category[]> => {
    const response = await client.get<Category[]>('/categories', {
      params: { includeInactive }
    });
    return response.data;
  },

  getById: async (id: string): Promise<Category> => {
    const response = await client.get<Category>(`/categories/${id}`);
    return response.data;
  },

  create: async (data: Partial<Category>): Promise<Category> => {
    const response = await client.post<Category>('/categories', data);
    return response.data;
  },

  update: async (id: string, data: Partial<Category>): Promise<Category> => {
    const response = await client.put<Category>(`/categories/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/categories/${id}`);
  },

  seedDefaults: async (): Promise<void> => {
    await client.post('/categories/seed');
  },
};
